import React, { useState } from "react";
import { mediaUrl } from "../../lib/services";

/** Comparateur avant / après : curseur horizontal (input range) qui révèle la photo « après ». */
const BeforeAfter = ({ before, after, alt = "", testid }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative aspect-[3/2] overflow-hidden rounded-xl bg-neutral-200 select-none" data-testid={testid}>
      <img src={mediaUrl(after)} alt={`${alt} — après`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={mediaUrl(before)} alt={`${alt} — avant`} className="absolute inset-0 h-full object-cover max-w-none" style={{ width: `${10000 / Math.max(pos, 1)}%` }} draggable={false} />
      </div>
      <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-white shadow-lg flex items-center justify-center text-neutral-700 text-xs font-bold">⇔</span>
      </div>
      <span className="absolute top-3 left-3 text-[11px] font-bold uppercase tracking-wider bg-neutral-900/70 text-white px-2 py-1 rounded">Avant</span>
      <span className="absolute top-3 right-3 text-[11px] font-bold uppercase tracking-wider bg-brand/90 text-white px-2 py-1 rounded">Après</span>
      <input type="range" min={0} max={100} value={pos} onChange={(e) => setPos(Number(e.target.value))} aria-label="Comparer avant / après"
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize" data-testid={testid ? `${testid}-slider` : undefined} />
    </div>
  );
};

export default BeforeAfter;
